import React from "react";
import { CardTitle, CardDescription } from "@/components/ui/card";
import ClientAvatar from "./ClientAvatar";

interface ClientCardHeaderProps {
  clientName: string;
  company: string;
  clientImage: string | null;
  initials: string;
  avatarColor: string;
  activityStatus: {
    status: "active" | "recent" | "inactive" | "unknown";
    text: string;
  };
  isShared?: boolean;
}

const ClientCardHeader = ({
  clientName,
  company,
  clientImage,
  initials,
  avatarColor,
  activityStatus,
  isShared = false
}: ClientCardHeaderProps) => {
  return (
    <div className="flex items-center gap-3">
      <ClientAvatar 
        imageUrl={clientImage}
        name={clientName}
        initials={initials} 
        avatarColor={avatarColor} 
      />
      <div>
        <CardTitle className="text-lg text-[#333B44]">
          {clientName}
        </CardTitle>
        {company && (
          <CardDescription className="text-sm text-[#5A636E]">
            {company}
          </CardDescription>
        )}
      </div>
    </div>
  );
};

export default ClientCardHeader;
